import ExportSidebar from "./ProSideBar";
import { Link } from 'react-router-dom';
import { PageHeader } from "./AuxiliaryFunctions";
import { useDispatch, useSelector } from "react-redux";
import UserDataService from "./services/user.serviceaux";
import OrganigramaDataService from "./services/organigrama.service";
import { useState, useEffect } from "react";
import Sidebar from "./Sidebar";
import './index.css';
import { IoMdBuild } from "react-icons/io";
import * as FaIcons from "react-icons/fa";
import { Col, Container, FormLabel, FormControl, Button, Row } from "react-bootstrap";
import OrganigramasList from "./OrganigramasList";
import NoPrivileges from "./NoPrivileges";
import { logout } from './actions/auth.js';

const Organigramas = () => {
  const { user: currentUser } = useSelector((state) => state.auth) 
  // Admin role is id = 3
  // Superadmin role is id = 4
  return (
    (currentUser.roles.includes(4))?(<OrganigramasAuth />):
    <>
      <NoPrivileges currentUser={currentUser}/>
    </>
  )
}

const OrganigramasAuth = () => {
  const { user: currentUser } = useSelector((state) => state.auth);	
  const [status, setStatus] = useState(0);
  const [primernombre, setPrimernombre] = useState("");
  const [primerapellido, setprimerapellido] = useState("");
  const [SortType, setSortType] = useState('DESC');
  const [SortField, setSortField] = useState('');
  const [OrganigramaFilterByDescr, setOrganigramaFilterByDescr] = useState('');
  const [listOfOrganigramas, setlistOfOrganigramas] = useState([]);

  const dispatch = useDispatch();
  

  const onChangeSortType = () => {
    setSortType(SortType == 'DESC'?'ASC':'DESC');
  }

  const onChangeSortField = (e) => {
    setSortField(e.target.value);
  }

  const onChangeOrganigramaFilterByDescr = (e) => {
    setOrganigramaFilterByDescr(e.target.value);
  }  

  const duplicarOrg = (orgid) => {
    OrganigramaDataService.duplicate(orgid)
    .then((resp) => {
      window.location.reload();
    })
    .catch(e => {
      if (e.response.status == 401) {
        console.log("status 401");
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
      }
    });
  };

  useEffect(() => {
    performSearch(OrganigramaFilterByDescr,SortField,SortType);
  },[OrganigramaFilterByDescr,SortField,SortType]);

  const performSearch = (descr,sortfield,sorttype) => {
    OrganigramaDataService.getOrganigramaByDescr(descr,sortfield,sorttype)
      .then(response => {
        console.log(response.data);
        setlistOfOrganigramas(response.data);
      })
      .catch(e => {
        if (e.response.status == 401) {
          console.log("status 401");
          dispatch(logout())
          .then(() => {
            window.location.reload();
          })
          .catch((error) => {
            console.error(error);
          });
        }        
        console.log(e);
      });
  };

  useEffect(() => {
    
    UserDataService.get(currentUser.id)
    .then(
      (response) => { 
        //console.log(response);
        //console.log(currentUser);
        setPrimernombre(response.data[0].primernombre);
        setprimerapellido(response.data[0].primerapellido);
        setStatus(response.data[0].habilitado);
        //performSearch(SortType,SortField,OrganigramaFilterByDescr);
      }
    )
    .catch((e) => {
      if (e.response.status == 401) {
        console.log("status 401");
        dispatch(logout())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error(error);
        });
      }
      console.log(e.response);
    });  
    
  }, []);

  return (
    <>
    <Sidebar />
    <div style={{display:'flex', flexDirection:'row', gap:'10px'}}>      
      <ExportSidebar roles={currentUser.roles}/>
        <Container>
        <PageHeader />                
          {(status === 1) && 
            <>
            
              <Row className='mb-2 d-flex'>
                <h5 className='mb-4' style={{width: "100%", textAlign: "center", marginLeft: "0%", color: "green" }}>Organigramas</h5>
                <Col lg={true}>
                  <FormLabel className='mb-2'>Filtrar por nombre:</FormLabel>       
                  <FormControl type="text" name="filterbyorganigrama" id="filterbyorganigrama" onChange={onChangeOrganigramaFilterByDescr}></FormControl>
                </Col>

                <Col lg={true}>
                  <FormLabel className='mb-2'>Ordenar por:</FormLabel>       
                  <FormControl as='select' onChange={onChangeSortField}>
                    <option value="id">ID organigrama</option>
                    <option value="nombreorganigrama">Nombre organigrama</option>
                  </FormControl>
                </Col>
              
                <Col sm={true}>
                  <FormLabel className='mb-2'>Asc/Desc:</FormLabel>       
                  <FormControl style={{maxWidth:"50px"}} as="button" onClick={onChangeSortType}><FaIcons.FaSortAmountDownAlt/></FormControl>
                </Col> 

              </Row>

              <Link to="/new-organigrama" className="mr-2 btn btn-secondary">Nuevo organigrama</Link>            
              <Button className="m-2 btn btn-secondary">Exportar</Button>        
              <Row>
                <OrganigramasList mode={0} listOfOrganigramas = {listOfOrganigramas} duplicarOrg={duplicarOrg}/>      
              </Row>
            

            </>
          }
          {(status === 0) && 
            <>
            <div className="main-frame-page">          
              <h5>Tu perfil aun no ha sido habilitado por un administrador.</h5>
              <div style={{backgroundColor:'', padding:'10px'}}>
                Cuando tu perfil esté habilitado tendrás acceso a más opciones en la plataforma!
              </div>
            </div>
            </>
          }    
        </Container>      
      </div>
    </>
  )
};
  
export default Organigramas;